import { useMemo } from 'react';

import useSearchQuery from '@shared/v2/hooks/useSearchQuery';

import { useRoomOptionsData } from '@/v2/components/pages/PackageView/contexts/RoomOptionsContext';
import { CtaButtonStatus } from '@/v2/components/pages/PackageView/hooks/useCtaButtonStatus/types';

const useCtaButtonStatus = () => {
  const { selectedRoomOption, roomOptions, travellerCount, isPreSearch } =
    useRoomOptionsData() || {};

  const { searchQuery } = useSearchQuery();
  const { originCode, packageOption } = searchQuery || {};

  const isOccupantsExceeded =
    travellerCount &&
    roomOptions?.main?.every(
      (roomOption) => travellerCount > (roomOption.roomType.maxOccupants ?? 0),
    );

  return useMemo((): CtaButtonStatus | null => {
    // Pre-Search
    if (isPreSearch) {
      if (!originCode) {
        return 'noFlyingFrom';
      }

      if (!packageOption) {
        return 'noPackageOption';
      }

      return 'checkAvailability';
    }

    // Post-Search
    if (!isPreSearch) {
      if (isOccupantsExceeded && !selectedRoomOption) {
        return 'changeTravellers';
      }

      if (!selectedRoomOption) {
        return 'changeDates';
      }

      if (selectedRoomOption) {
        return 'reserve';
      }
    }

    // Something is wrong if we get here
    return null;
  }, [
    isOccupantsExceeded,
    isPreSearch,
    originCode,
    packageOption,
    selectedRoomOption,
  ]);
};

export default useCtaButtonStatus;
